import { ScenarioHotspot, ScenarioQuestion } from './scenario.model';

export interface ScenarioCockpitPanel {
  label: string;
  name: string;
  imageUrl: string;
  hotspots: ScenarioHotspot[];
}

/** Coordinates are percentages of the full, uncropped supplied panel images. */
export const COCKPIT_PANELS: ScenarioCockpitPanel[] = [
  {
    label: 'MFD', name: 'Multi-function display', imageUrl: 'assets/scenarios/cockpit/MFD.webp',
    hotspots: [
      { label: 'NAV tuning knob', x: 12, y: 23 },
      { label: 'Heading knob', x: 12.5, y: 41 },
      { label: 'Altitude knob', x: 12.5, y: 92 },
      { label: 'COM tuning knob', x: 88.5, y: 23 },
      { label: 'CRS / BARO knob', x: 88.5, y: 41 },
      { label: 'Range / pan knob', x: 88, y: 58 },
      { label: 'Direct-to', x: 85, y: 69.7, correct: true },
      { label: 'FMS knob', x: 88, y: 92 },
    ],
  },
  {
    label: 'PFD', name: 'Primary flight display', imageUrl: 'assets/scenarios/cockpit/PFD.webp',
    hotspots: [
      { label: 'NAV tuning knob', x: 11.7, y: 23 },
      { label: 'Heading knob', x: 12.1, y: 41 },
      { label: 'Altitude knob', x: 12.1, y: 92 },
      { label: 'COM tuning knob', x: 88.2, y: 23 },
      { label: 'CRS / BARO knob', x: 88.2, y: 41 },
      { label: 'Range / pan knob', x: 87.7, y: 58 },
      { label: 'Direct-to', x: 84.7, y: 69.7, correct: true },
      { label: 'FMS knob', x: 87.7, y: 92 },
    ],
  },
];

export function cockpitExampleQuestion(): ScenarioQuestion {
  const panel = COCKPIT_PANELS[0];
  return {
    kind: 'cockpit-control', points: 5, title: 'Which button opens Direct-to waypoint selection?',
    prompt: 'Click the Direct-to button on the display bezel.',
    imageUrl: panel.imageUrl, hotspots: panel.hotspots.map(spot => ({ ...spot })),
    explanation: 'The Direct-to button is marked with a D and an arrow, above FPL on the right bezel.',
  };
}
